import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { ref, computed, PropType, useAttrs } from 'vue'
import { useRouter } from 'vue-router'
import type { IFunction, ResourcesChildrenTree } from '@y/types'


export default /*@__PURE__*/_defineComponent({
  __name: 'DrawerNavItem',
  props: {
  menu: {
    type: Object as PropType<ResourcesChildrenTree>,
    required: true,
  },
  prePath: {
    type: String as PropType<string>,
    default: '',
  },
},
  setup(__props) {

const props = __props

const attrs = useAttrs()
const router = useRouter()

const menu = ref(props.menu)

const isSubMenu = computed(() => props.menu.children && props.menu.children.some(child => child.type === '1'))

const convertPrePath = (menu: ResourcesChildrenTree) => {
  const { parentId } = menu
  if (!parentId || parentId === '0') {
    return `/app${menu.urlPath}`
  }
  const { prePath } = props
  return `${prePath}`
}

const handleClick = () => {
  const { prePath } = props
  const call = attrs.onCall as IFunction
  const path = `${prePath}${props.menu.urlPath}`
  router.push({
    path,
  })
  call()
}

return (_ctx: any,_cache: any) => {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_drawer_nav_item = _resolveComponent("drawer-nav-item", true)!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!

  return (menu.value.children && menu.value.children.length && isSubMenu.value)
    ? (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 0,
        index: menu.value.urlPath
      }, {
        title: _withCtx(() => [
          _createVNode(_component_app_icon, {
            name: menu.value.attributes.resourceIcon || 'apps-line'
          }, null, 8, ["name"]),
          _createElementVNode("span", {
            class: _normalizeClass({ c_font16: menu.value.type === '5' })
          }, _toDisplayString(menu.value.text), 3)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.value.children, (subMenu) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: subMenu.urlPath
            }, [
              (subMenu.type === '1')
                ? (_openBlock(), _createBlock(_component_drawer_nav_item, _mergeProps({
                    key: 0,
                    menu: subMenu,
                    "pre-path": convertPrePath(menu.value)
                  }, { ref_for: true }, _ctx.$attrs), null, 16, ["menu", "pre-path"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]),
        _: 1
      }, 8, ["index"]))
    : (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 1,
        index: menu.value.urlPath,
        onClick: handleClick
      }, {
        title: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(menu.value.text), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_app_icon, {
            name: menu.value.attributes.resourceIcon || 'apps-line'
          }, null, 8, ["name"])
        ]),
        _: 1
      }, 8, ["index"]))
}
}

})